import { connect } from "react-redux";
import { getSpSetting } from "store/selector/sp.selector";
import FeedbackReports from "./FeedbackReports";

const mapStateToProps = (state) => {
  const settings = getSpSetting(state);
  return { settings };
};

export default connect(mapStateToProps, {})(FeedbackReports);
